var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inventory-item--edit flex__center pointer",on:{"click":_vm.emitToggleModal}},[_c('font-awesome-icon',{staticClass:"mr-10",attrs:{"icon":"edit","size":"sm"}}),_vm._v("View ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }